import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import React__default from 'react';
import { UserMenu } from './user-menu.js';

var MobileView = function MobileView() {
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isUserMenuShow = _React$useState2[0],
      setIsUserMenuShow = _React$useState2[1];

  var handleMenuClick = function handleMenuClick() {
    setIsUserMenuShow(!isUserMenuShow);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("i", {
    className: "menu-btn-icon",
    onClick: handleMenuClick
  }), /*#__PURE__*/React__default.createElement(UserMenu, {
    isShow: isUserMenuShow
  }));
};

export { MobileView };
